<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
	<div class="top-bar" v-show="!hide" :class="{ 'impersonation': impersonated }">
		<div class="my-presence-box">
			<my-presence />
		</div>

		<!-- Buttons -->
		<div class="button-outer-container" style="flex-grow:5">
			<div class="button-container" id="TopbarButtonContainer">
				<TopbarButton v-if="ss.runtime.selectedSection===SectionType.DASHBOARD || !dashboards.useTopbar"
					:icon="GlyphIconName['thumbnails-small']"
					:label="dashboards.useTopbar ? dashboards.dashboard?.name + '' : t('topbar.buttons.dashboard')"
					:click="selectSection"
					id="DASHBOARD"
					:selected="ss.runtime.selectedSection===SectionType.DASHBOARD"
					:bid="registerButtonId(SectionType.DASHBOARD)"
				/>
				<TopbarButton v-if="dashboards.useTopbar" v-for="item in dashboards.labelsForTopbar" v-bind:key="item._id"
					:icon="GlyphIconName['thumbnails-small']"
					:label="item.label"
					:click="selectSection"
					:id="'DASHBOARD-' + item._id"
					:selected="ss.runtime.selectedSection==='DASHBOARD-'+item._id"
					:bid="registerButtonId('DASHBOARD-' + item._id)"
				/>
				<TopbarButton
					:icon="GlyphIconName['book-address']"
					:label="t('topbar.buttons.phonebook')"
					:click="selectSection"
					id="PHONEBOOK"
					:selected="ss.runtime.selectedSection===SectionType.PHONEBOOK"
					:bid="registerButtonId(SectionType.PHONEBOOK)"
				/>
				<TopbarButton v-if="ss.auth?.recordingMode!=='NEVER' && !impersonated"
					:icon="GlyphIconName['equalizer-bars']"
					:label="t('topbar.buttons.recordings')"
					:click="selectSection"
					id="RECORDINGS"
					:selected="false"
					:recording="recordingState.isRecording"
					:bid="registerButtonId(SectionType.RECORDINGS)"
				/>
				<TopbarButton v-if="!impersonated"
					:icon="GlyphIconName['voicemail']"
					:label="t('topbar.buttons.voicemail')"
					:click="selectSection"
					id="VOICEMAIL"
					:selected="false"
					:badge="voicemailBadge"
					:bid="registerButtonId(SectionType.VOICEMAIL)"
				/>
				<TopbarButton
					:icon="GlyphIconName['list']"
					:label="t('topbar.buttons.calls')"
					:click="selectSection"
					id="CALLS"
					:selected="false"
					:badge-nummeric="callHistory.missedCallsCount"
					:bid="registerButtonId(SectionType.CALLS)"
				/>
			</div>
		</div>

		<div class="mainsearch grow-0 shrink-0">

			<!-- phone and audio device selector -->
			<div class="phone-and-headset" @click="pacmanClick2">
				<GlyphIcon :icon="GlyphIconName['phone-old']" size="14" style="flex-grow:0;flex-shrink:0" />
				<div style="flex-grow:0;flex-shrink:0;padding-left:2px;white-space: nowrap" :class="{ 'softphone-not-connected': softphoneNotConnected}">{{ myPhoneName }}</div>

				<GlyphIcon @click="audioInDeviceMenuToggle($event)" v-if="ss.settings.softphoneId"
					:icon="headsetInUse ? GlyphIconName['headset'] : GlyphIconName['mic']"
					size="14"
					class="audio-device-icon"
				/>
				<div @click="audioInDeviceMenuToggle($event)" v-if="ss.settings.softphoneId" class="audio-device-label">{{ headsetDeviceName }}</div>
				<Menu ref="audioInDeviceMenu" :model="audioInDeviceMenuItems" popup>
					<template #item="{ item, props }">
						<a v-ripple class="flex items-center" v-bind="props.action">
							<GlyphIcon :icon="item.icon as GlyphIconName" size="14" color="var(--p-text-color)" />
							<span>{{ item.label }}</span>
						</a>
					</template>
				</Menu>
			</div>

			<div @click="pacmanClick1" class="search-helper">{{ t('topbar.searchtip') }}</div>

			<InputText
				type="search"
				id="MainSearchInput"
				class="search-field"
				:class="{'search-field-extra' : showSearchResults, 'search-field-no-match': !showSearchResults && searchFilter }"
				:placeholder="t('topbar.searchPlaceholder')"
				v-model="searchFilter"
				@keydown="keycheck"
				@input="search"
				size="small"
			/>
			<div class="search-results-box box-shadow2" v-show="showSearchResults" id="SearchResultBox" >
				<div v-for="m in searchResults" :id="'searchResultItem' + m.index" :key="m._id" @click="searchSelect(m, $event)" class="search-result-item" :class="{'selected': highlightedSearchResult === m}">

					<div v-if="m.type !== SearchResultType.DIRECT">
						<div class="result-item-employee" v-if="m.type === SearchResultType.EMPLOYEE">
							<EmployeePicture :picture="(m.item as unknown as Employee).picture" :size="36" :spinner="true" :name="(m.label)" />
							<PresenceIcon :state="(m.item as unknown as Employee).presence?.state as EmployeePresenceState" :size="15" class="presence-state" />
							<div class="employee-oncall" :class="{'active': m.type === SearchResultType.EMPLOYEE && (m.item as unknown as Employee).extensionsState !== ExtensionState.IDLE}">
								<GlyphIcon :icon="GlyphIconName['call']" color="#fff" size="14" />
							</div>
						</div>

						<div class="result-item-icon" style="padding-top:5px;padding-left:2px" v-if="m.type === SearchResultType.PHONEBOOK">
							<GlyphIcon v-if="!(m.item as PbxPhonebookContact).picture" :icon="GlyphIconName['book-address']" size="27" color="var(--p-text-muted-color)" style="margin-top:-1px" />
							<EmployeePicture v-if="(m.item as PbxPhonebookContact).picture" :picture="(m.item as PbxPhonebookContact).picture as string" :size="37" :spinner="true" :name="(m.label)" style="margin-top:-7px;margin-left:-3px" />
						</div>

						<div class="result-item-icon" v-if="m.type === SearchResultType.SHORTCUT">
							<GlyphIcon :icon="GlyphIconName['globe']" size="35" color="var(--p-text-muted-color)" />
						</div>

						<div class="headline" v-html="m.label"></div>

						<div class="subline">
							<span v-for="field in m.fields" :key="field" class="badge" v-html="field"></span>
						</div>
					</div>

					<div v-if="m.type === SearchResultType.DIRECT" class="flex items-center">
						<div class="result-item-icon"><GlyphIcon :icon="GlyphIconName['call']" size="34" color="var(--p-text-muted-color)" /></div>
						<div class="headline">{{ ss.cutNationalPrefix(m.item as string, true) }}</div>
					</div>
				</div>
			</div>
			<ContextMenu ref="searchContextMenu" :model="searchContextMenuItems" append-to="self" popup
				@hide="searchContextMenuHideEvent"
				@show="searchContextMenuShowEvent"
				id="searchContextMenu" />
			<SetPresenceModal ref="mySetPresenceModal" />
		</div>
	</div>
</template>

<script setup lang="ts">
import globalEvents from '@/utilities/GlobalEvents'
import TopbarButton from './TopbarButton.vue'
import GlyphIcon from '@/components/GlyphIcon.vue'
import MyPresence from './MyPresence.vue'
import { useEmployeesStore } from '@/stores/Employees'
import { usePhonebookStore } from '@/stores/Phonebook'
import { useDashboardsStore } from '@/stores/Dashboards'
import { useSettingsStore } from '@/stores/Settings'
import EmployeePicture from '@/components/EmployeePicture.vue'
import PresenceIcon from '@/components/PresenceIcon.vue'
import { useRecordingStateStore } from '@/stores/RecordingState'
import SipClient from '@/utilities/SipClient'
import { useMediaDevicesStore } from '@/stores/MediaDevices'
import { useI18n } from 'vue-i18n'
import { useCallHistoryStore } from '@/stores/CallHistory'
import logger from '@/utilities/Logger'
import { computed, nextTick, ref } from 'vue' // eslint-disable-line
import { SearchResultType, SearchResultItemType, type SearchResult, type SearchResultNumber } from './Topbar.types'
import { SectionType } from '@/stores/Settings.types'
import type Employee from '@/stores/Employee'
import { PbxPhonebookContactPhoneNumberType, PbxPhonebookContactType, type PbxPhonebookContact } from '@/TcxApi/PbxPhonebook'
import { PbxAppDashboardItemType, PbxAppEmployeesType, type PbxAppDashboardItemShortcuts, type PbxAppEmployeesExtensionWithDate } from '@/TcxApi/PbxApp'
import { DK_NUMBER_TYPE, dkNumberType, dynamicSortMultiple, getUnique, randomString, sleep } from '@/utilities/Tools'
import { useApiStore } from '@/stores/Api'
import { MediaDeviceType, type MediaDeviceSettingsItem } from '@/stores/MediaDevices.types'
import { GlyphIconName } from '@/stores/GlyphIcons.types'
import Menu from 'primevue/menu'
import type { MenuItem } from 'primevue/menuitem'
import { EmployeePresenceState } from '@per_moeller/tcx-realtime-client'
import { ExtensionState } from '@/stores/Employee.types'
import type TieredMenu from 'primevue/tieredmenu'
import { type EmployeeResponse, type EmployeeRequest } from '@/TcxApi/Employee'
import ContextMenu from 'primevue/contextmenu'
import SetPresenceModal from '@/components/modals/SetPresenceModal.vue'

const employees = useEmployeesStore()
const phonebook = usePhonebookStore()
const dashboards = useDashboardsStore()
const ss = useSettingsStore()
const recordingState = useRecordingStateStore()
const api = useApiStore()
const sipClient = SipClient.instance
const mediaDevices = useMediaDevicesStore()
const { t } = useI18n()
const callHistory = useCallHistoryStore()

const searchFilter = ref('')
const hide = ref(false) // for hiding topbar when in wallboard mode
const searchResults = ref<SearchResult[]>([])
const highlightedSearchResult = ref<null | SearchResult>(null)
const showSearchResults = ref(false)
const voicemailBadge = ref<string | undefined>(undefined)
const pacmanCounter = ref(0)
const removeClickListener = ref<null | (() => void)>(null)
const buttonsIds = ref<string[]>([])
const searchContextMenu = ref<InstanceType<typeof TieredMenu>>()
const mySetPresenceModal = ref<InstanceType<typeof SetPresenceModal>>()
const searchContextMenuIsVisible = ref(false)

// #region Audio device selection

const audioInDeviceMenu = ref<InstanceType<typeof Menu> | null>(null)

const audioInDeviceMenuItems = computed(() => {
	const items: MenuItem[] = []

	for (const device of mediaDevices.audioInDevices) {
		if (device.disabled) { continue } // Skip system default and virtual devices - they cannot be a preferred device

		const item: MenuItem = { label: device.label, command: () => audioInDeviceSelect(device), icon: device.selected ? GlyphIconName['check'] : GlyphIconName['blank'] }

		items.push(item)
	}
	return items
})

function audioInDeviceMenuToggle(event: Event) {
	audioInDeviceMenu.value?.toggle(event)
}

const headsetInUse = computed(() => sipClient.headsets.jabra.use.value || sipClient.headsets.sennheiser.use.value || sipClient.headsets.yealink.use.value)
const headsetDeviceName = computed(() => {
	if (sipClient.headsets.jabra.use.value) { return sipClient.headsets.jabra.useDeviceName.value }
	if (sipClient.headsets.sennheiser.use.value) { return sipClient.headsets.sennheiser.useDeviceName.value }
	if (sipClient.headsets.yealink.use.value) { return sipClient.headsets.yealink.useDeviceName.value }
	return mediaDevices.microphoneDevice?.label ?? 'n/a'
})

// #endregion

function registerButtonId(id: string) {
	buttonsIds.value.push(id)
}

function pacmanClick1() {
	if (pacmanCounter.value === 0 || pacmanCounter.value === 2) {
		pacmanCounter.value++
	} else {
		pacmanCounter.value = 0
	}
}

function pacmanClick2() {
	if (pacmanCounter.value === 1) {
		pacmanCounter.value++
	} else if (pacmanCounter.value === 3) {
		pacmanCounter.value = 0
		pacman()
	} else {
		pacmanCounter.value = 0
	}
}

function pacman() {
	const iframe = document.createElement('iframe')

	iframe.allow = 'autoplay; fullscreen; picture-in-picture; xr-spatial-tracking; clipboard-write'
	iframe.setAttribute('sandbox', 'allow-scripts allow-presentation allow-same-origin')
	iframe.allowFullscreen = true

	iframe.src = 'https://pacman.telecomx.dk'
	iframe.style.position = 'absolute'
	iframe.style.left = '50%'
	iframe.style.top = '50%'
	iframe.style.transform = 'translate(-50%, -50%)'
	iframe.style.zIndex = '1100'
	iframe.width = '1200px'
	iframe.height = '1000px'
	document.body.appendChild(iframe)
	iframe.style.opacity = '0.7'

	const cover = document.createElement('div')

	cover.style.position = 'absolute'
	cover.style.left = '0'
	cover.style.right = '0'
	cover.style.top = '0'
	cover.style.bottom = '0'
	cover.style.backgroundColor = '#555555B0'
	cover.style.zIndex = '1099'
	cover.style.cursor = 'pointer'
	cover.onclick = () => {
		document.body.removeChild(iframe)
		document.body.removeChild(cover)
		document.body.style.overflow = 'scroll'
	}
	document.body.appendChild(cover)

	document.body.style.overflow = 'hidden'
}

function selectSection(section: SectionType | string) {
	if (section.startsWith('DASHBOARD-')) {
		globalEvents.emit('Dashboard:Select', section.substring(10))
		ss.runtime.selectedSection = section
	} else if (section === SectionType.DASHBOARD) {
		ss.runtime.selectedSection = section
	} else if (section === SectionType.PHONEBOOK) {
		ss.runtime.selectedSection = SectionType.PHONEBOOK
	} else {
		if (section === SectionType.RECORDINGS) {
			ss.recordingsModalVisible = !ss.recordingsModalVisible
		}

		if (section === SectionType.VOICEMAIL) {
			ss.voicemailModalVisible = !ss.voicemailModalVisible
		}

		if (section === SectionType.CALLS) {
			ss.cdrModalVisible = !ss.cdrModalVisible
		}
	}
}

// #region Search handling

/**
 * Perform search based on query
 * @param query Search query
 */
function search(event: Event) {
	const start = new Date()
	const target = event.target as HTMLInputElement
	let query = target.value

	if (query === '' || query === '.') {
		clearSearch()
		return
	}

	// . = only search employees
	let onlyEmployees = false
	let state: EmployeePresenceState | undefined = undefined

	if (query.startsWith('.')) {
		onlyEmployees = true
		query = query.substring(1)
	}

	if (query.includes(' ') && /^\+?\d+$/.test(query.replace(/ /g, ''))) {
		query = query.replace(/ /g, '')
	}

	for (const part of query.split(/ +/)) {
		if (part === ':ledig' || part === ':available') {
			state = EmployeePresenceState.AVAILABLE
		} else if (part === ':optaget' || part === ':busy') {
			state = EmployeePresenceState.BUSY
		} else if (part === ':ude' || part === ':out') {
			state = EmployeePresenceState.OUT_OF_OFFICE
		} else if (part === ':fri' || part === ':off') {
			state = EmployeePresenceState.OFF_WORK
		} else if (part === ':ferie' || part === ':holiday') {
			state = EmployeePresenceState.HOLIDAY
		}
	}

	if (state) {
		onlyEmployees = true
	}
	query = query.replace(/:\w+/g, '').replace(/:/g, '').replace(/ {2,}/g, ' ').trim()

	let matches: SearchResult[] = []
	const rawQuery = query.trim().replace('\u202c', '').replace('\u202d', '').toLowerCase()

	query = query.trim().replace('\u202c', '').replace('\u202d', '').toLowerCase().replace(/ {2}/g, ' ')
		.replace(/\./g, '\\.')
		.replace(/\*/g, '\\*')
		.replace(/-/g, '\\-')
		.replace(/[[\]|(),$^{}\t]/g, '')
		.replace(/\+/g, '\\+')

	if (query.replace(/ /g, '').replace(/-/g, '').match(/^\+?\d+$/) != null) {
		query = query.replace(/ /g, '').replace(/-/g, '')
	}

	const rxIs = new RegExp('(^|[ \n\r\t.,\'"+!?-]+)' + query + '([ \n\r\t.,\'"+!?-]+|$)') // Match a word/sentence which is the query
	const rxBeginsWith = new RegExp('(^|[ \n\r\t.,\'"+!?-]+)' + query) // Match if a word/sentence begins with the query
	const rxContains = new RegExp(query) // Match if contains query
	const rxWords = new RegExp('^(?=.*' + query.replace(' ', ')(?=.*') + ')') // Match if all words could be found in string
	const scoreExactMatch = 500
	const scoreMatch = 100
	const scoreStartsWith = 70
	const scoreContains = 40

	function compare(against: string, penalty: number, fields: string[]) {
		if (!rawQuery) { return 0 }
		if (!against) { return 0 }
		if (fields.includes(against)) { return 0 }
		const original = against

		against = against.toLowerCase().trim()
		let score = 0
		if (rxIs.test(against)) { score += scoreMatch - penalty; fields.push(original) }
		else if (rxWords.test(against)) { score += scoreMatch - penalty; fields.push(original) }
		else if (rxBeginsWith.test(against)) { score += scoreStartsWith - penalty; fields.push(original) }
		else if (rxContains.test(against)) { score += scoreContains - penalty; fields.push(original) }
		return score
	}

	// Search employees
	for (const employee of employees.employees) {
		let score = 0
		const fields: string[] = []

		if (employee.type === PbxAppEmployeesType.EMPLOYEE) {
			// Employee
			if (employee.name && employee.name.toLowerCase() === rawQuery.toLowerCase()) {
				score += scoreExactMatch
			} else {
				score += compare(employee.name, 0, fields)
			}
			if (employee.title) { score += compare(employee.title, 30, fields) }
			if (employee.department) { score += compare(employee.department, 30, fields) }
			if (employee.address) { score += compare(`${employee.address.address}, ${employee.address.zip} ${employee.address.city}`.toLowerCase(), 20, fields) }
			if (employee.extensions.length > 0) {
				for (const extension of employee.extensions) {
					if (rawQuery && extension.number === rawQuery) { score += scoreExactMatch; fields.push(extension.number) }
					else if (rawQuery && extension.number && extension.number.startsWith(rawQuery)) { score += scoreStartsWith; fields.push(extension.number) }

					if (extension.direct) {
						if (ss.cutNationalPrefix(extension.direct) === rawQuery || extension.direct === rawQuery) { score += scoreExactMatch; fields.push(extension.direct) }
						else if (rawQuery && (ss.cutNationalPrefix(extension.direct)?.startsWith(rawQuery) || extension.direct?.startsWith(rawQuery))) { score += scoreStartsWith; fields.push(extension.direct) }
					}

					if (extension.mobile && extension.mobile.length > 0) {
						for (const mobile of extension.mobile) {
							if (ss.cutNationalPrefix(mobile) === rawQuery || mobile === rawQuery) { score += scoreExactMatch; fields.push(mobile) }
							else if (rawQuery && (ss.cutNationalPrefix(mobile)?.startsWith(rawQuery) || mobile.startsWith(rawQuery))) { score += scoreStartsWith; fields.push(mobile) }
						}
					}
				}
			}
			if (state) {
				const busyInCall = !!employee.currentCall

				if (employee.presence?.state === state) {
					if (state === EmployeePresenceState.AVAILABLE && !busyInCall) {
						score += 2
					} else {
						score += 1
					}
				} else {
					score = 0
				}
			}
			if (score === 1 && rawQuery) { score = 0 }
		} else if (!state) {
			// Extension
			if (employee.name && employee.name.toLowerCase() === rawQuery.toLowerCase()) {
				score += scoreExactMatch - 1
			} else {
				score += compare(employee.name, 1, fields)
			}
			if (employee.extensions.length > 0) {
				const extension = employee.extensions[0] as PbxAppEmployeesExtensionWithDate
				if (rawQuery && extension.number === rawQuery) { score += scoreExactMatch - 1; fields.push(extension.number) }
				else if (extension.number && rawQuery && extension.number.startsWith(rawQuery)) { score += scoreStartsWith - 1; fields.push(extension.number) }

				if (extension.direct) {
					if (ss.cutNationalPrefix(extension.direct) === rawQuery || extension.direct === rawQuery) { score += scoreExactMatch - 1; fields.push(extension.direct) }
					else if (rawQuery && (ss.cutNationalPrefix(extension.direct)?.startsWith(rawQuery) || extension.direct?.startsWith(rawQuery))) { score += scoreStartsWith - 1; fields.push(extension.direct) }
				}

				if (extension.mobile && extension.mobile.length > 0) {
					for (const mobile of extension.mobile) {
						if (ss.cutNationalPrefix(mobile) === rawQuery || mobile === rawQuery) { score += scoreExactMatch - 1; fields.push(mobile) }
						else if (rawQuery && (ss.cutNationalPrefix(mobile)?.startsWith(rawQuery) || mobile.startsWith(rawQuery))) { score += scoreStartsWith - 1; fields.push(mobile) }
					}
				}
			}
		}

		if (score > 0) {
			const numbers: SearchResultNumber[] = []
			const sms: string | undefined = employee.primaryExtension?.mobile[0] ? ss.cutNationalPrefix(employee.primaryExtension.mobile[0]) : undefined
			const email = employee.emailAddress?.includes('@') && !employee.emailAddress?.includes('@xtele.dk') ? employee.emailAddress : undefined

			for (const extension of employee.extensions) {
				if (extension.number) {
					numbers.push({ label: 'Lokalnummer', type: 'EXTENSION', number: extension.number })
				}
				else if (extension.direct) {
					numbers.push({ label: 'Direkte', type: 'DIRECT', number: ss.cutNationalPrefix(extension.direct) as string })
				}
				else if (extension.mobile[0]) {
					numbers.push({ label: 'Mobil', type: 'MOBILE', number: ss.cutNationalPrefix(extension.mobile[0]) as string })
				}
			}

			if (fields.length === 0 || (fields.length === 1 && fields[0] === employee.name)) {
				if (employee.title) { fields.push(employee.title) }
				if (employee.department) { fields.push(employee.department) }
				if (employee.address) { fields.push(employee.address.city) }
			}

			matches.push({
				score: score,
				type: SearchResultType.EMPLOYEE,
				item: employee as unknown as Employee,
				label: employee.name,
				fields: fields,
				_id: employee._id,
				itemType: SearchResultItemType.EMPLOYEE,
				index: 0,
				numbers: numbers,
				email: email,
				sms: sms ?? undefined
			})
		}
	}

	logger.info(`Search employees took ${new Date().getTime() - start.getTime()}ms`)

	if (!onlyEmployees && rawQuery) {
		// Search phonebook
		for (const contact of phonebook.contacts) {
			let score = 0
			const fields: string[] = []
			const name = [ contact.givenName || '', contact.familyName || ''].join(' ').trim()

			if (name) {
				if (name.toLowerCase() === rawQuery.toLowerCase()) { score += scoreExactMatch }
				else { score += compare(name, 10, fields) }
			}
			if (contact.company) { score += compare(contact.company, 10, fields) }
			if (contact.title) { score += compare(contact.title, 30, fields) }
			if (contact.department) { score += compare(contact.department, 30, fields) }
			if (contact.addresses && contact.addresses.length > 0) {
				for (const addr of contact.addresses) {
					const address = `${addr.street || ''}, ${addr.zip || ''} ${addr.city || ''}`.toLowerCase().trim()
					if (address) { score += compare(address, 20, fields) }
				}
			}
			if (contact.phoneNumbers && contact.phoneNumbers.length > 0) {
				for (const pn of contact.phoneNumbers) {
					if (pn.number && (ss.cutNationalPrefix(pn.number) === rawQuery || pn.number === rawQuery)) {
						if (!fields.includes(pn.number)) {
							score += scoreExactMatch
							fields.push(pn.number)
						}
					}
					else if (pn.number && (ss.cutNationalPrefix(pn.number)?.startsWith(rawQuery) || pn.number.startsWith(rawQuery))) {
						if (!fields.includes(pn.number)) {
							score += scoreStartsWith
							fields.push(pn.number)
						}
					}
				}
			}
			if (contact.emailAddresses && contact.emailAddresses.length > 0) {
				contact.emailAddresses.forEach(ea => {
					score += compare(ea.address, 30, fields)
				})
			}
			if (contact.notes) { score += compare(contact.notes, 30, fields) }
			if (contact.shortNumber && contact.shortNumber === rawQuery) {
				score += scoreExactMatch
				fields.push(contact.shortNumber)
			}

			if (score > 0) {
				if (fields.length === 0 || (fields.length === 1 && fields[0] === [contact.givenName || '', contact.familyName || ''].join(' ').trim()) ||
					(fields.length === 1 && fields[0] === contact.company)) {
					if (contact.phoneNumbers.length > 0 && contact.phoneNumbers[0]) {
						fields.push(contact.phoneNumbers[0].number)
					}
					if (contact.addresses.length > 0 && contact.addresses[0]) {
						const addr = contact.addresses[0]

						fields.push(`${addr.street || ''}, ${addr.zip || ''} ${addr.city || ''}`.toLowerCase().trim())
					}
				}

				const numbers: SearchResultNumber[] = []
				let sms: string | undefined = undefined
				const email = contact.emailAddresses.find(ea => ea.type === 'WORK')?.address ?? contact.emailAddresses[0]?.address

				for (const pn of contact.phoneNumbers) {
					numbers.push({ label: t('common.' + pn.type.toLowerCase()), type: pn.type, number: ss.cutNationalPrefix(pn.number) as string })
					if (!sms && pn.type === PbxPhonebookContactPhoneNumberType.MOBILE) { sms = pn.number }
				}

				matches.push({
					score: score,
					type: SearchResultType.PHONEBOOK,
					item: contact,
					label: contact.type === PbxPhonebookContactType.COMPANY ? (contact.company as string) : [contact.givenName, contact.familyName].join(' ') + (contact.company ? ` - ${contact.company}` : ''), // NOSONAR
					fields: fields,
					_id: contact._id,
					itemType: SearchResultItemType.OTHER,
					index: 0,
					numbers: numbers,
					email: email ?? undefined,
					sms: sms ?? undefined
				})
			}
		}

		// Search shortcuts
		if (dashboards.dashboard) {
			for (const panel of dashboards.dashboard.items) {
				if (panel.type === PbxAppDashboardItemType.SHORTCUTS) {
					for (const sc of (panel as PbxAppDashboardItemShortcuts).shortcuts) {
						let score = 0
						const fields: string[] = []

						score += compare(sc.name, 20, fields)
						if (ss.cutNationalPrefix(sc.number) === rawQuery || sc.number === rawQuery) { score += scoreMatch - 20; fields.push(sc.number) }
						else if (ss.cutNationalPrefix(sc.number)?.startsWith(rawQuery) || sc.number.startsWith(rawQuery)) { score += scoreStartsWith - 20; fields.push(sc.number) }

						if (score > 0) {
							matches.push({
								score: score,
								type: SearchResultType.SHORTCUT, item: sc,
								label: sc.name,
								fields: fields,
								_id: randomString(20),
								itemType: SearchResultItemType.OTHER,
								index: 0,
								numbers: [ { label: t('common.shortcut'), type: 'MAIN', number: ss.cutNationalPrefix(sc.number) as string } ],
								email: undefined,
								sms: dkNumberType(sc.number) === DK_NUMBER_TYPE.MOBILE ? sc.number : undefined
							})
						}
					}
				}
			}
		}
	}

	// | logger.info(`Search matches took ${new Date().getTime() - start.getTime()}ms - ${matches.length} matches`)

	// sort by score and grab top 15
	matches.sort(dynamicSortMultiple('-score', 'label'))
	matches = matches.slice(0, 15)

	// Add number to top if input is a phone number that can be called
	const numberQuery = rawQuery.replace(/-/g, '').replace(/ /g, '')
	let label = numberQuery
	let sms: string | undefined = undefined

	if (numberQuery.match(/^(\+?\d+|[*#0-9]+)$/)) {
		const employee = employees.findEmployeeFromNumber(numberQuery)
		if (!employee) { // Only add number if it is not an employee - because thet we already have it in the list
			if (numberQuery.startsWith(ss.pbxSettings.nationalPrefix) || numberQuery.length === 8) {
				const dkNumber = numberQuery.length === 8 ? ss.pbxSettings.nationalPrefix + numberQuery : numberQuery
				const numberType = dkNumberType(dkNumber)

				label = numberType === DK_NUMBER_TYPE.MOBILE ? t('common.mobile') : t('common.fixed')
				if (numberType === DK_NUMBER_TYPE.MOBILE) { sms = dkNumber }
			}

			matches.unshift({
				score: 0,
				type: SearchResultType.DIRECT,
				item: numberQuery,
				label: rawQuery,
				fields: [ rawQuery ],
				_id: randomString(20),
				itemType: SearchResultItemType.OTHER,
				index: 0,
				numbers: [ { label: label, type: 'MAIN', number: rawQuery } ],
				sms: sms
			})
		}
	}

	if (matches.length === 0) {
		clearSearch(true)
	} else {
		matches.forEach((match, index) => {
			match.index = index
			match.fields = match.fields.filter(field => field !== match.label).map(field => highlight(ss.cutNationalPrefix(field, true, true) as string, query))
			match.fields = getUnique(match.fields)
			match.label = match.itemType === SearchResultItemType.EMPLOYEE ? match.label : highlight(ss.cutNationalPrefix(match.label, true, true) as string, query)
		})
		searchResults.value = matches
		highlightedSearchResult.value = matches[0] as SearchResult
		showSearchResults.value = true
		removeClickListener.value = hideOnClickOutside(document.getElementById('SearchResultBox') as HTMLElement)
	}

	// | logger.info(`Search took ${new Date().getTime() - start.getTime()}ms`)
}

/**
 * Highlight a text selection inside a string
 * @param txt String to highlight selection inside
 * @param hl Text to highlight
 * @returns String with highlighted selection as HTML
 */
function highlight(txt: string, hl: string) {
	if (!txt) { return txt }

	const lcTxt = txt.toLowerCase()
	const hlBits = hl.toLowerCase().split(/ +/)
	const hls: { from: number, to: number }[] = []

	for (const hlBit of hlBits) {
		for (let index = 0; index < txt.length; index++) {
			if (lcTxt.substring(index, index + hlBit.length) === hlBit) {
				hls.push({ from: index, to: index + hlBit.length - 1 })
				index += hlBit.length // NOSONAR
			}
		}
	}

	let out = ''

	for (let index = 0; index < txt.length; index++) {
		if (hls.find(str => str.from === index)) {
			out += '<b>'
		}
		out += txt[index]
		if (hls.find(str => str.to === index)) {
			out += '</b>'
		}
	}
	return out
}

function clearSearch(notFilter?: boolean) {
	showSearchResults.value = false
	highlightedSearchResult.value = null
	if (!notFilter) { searchFilter.value = '' }
	searchResults.value = []
	if (removeClickListener.value) {
		removeClickListener.value()
		removeClickListener.value = null
	}
}

function searchSelect(item: SearchResult, event: MouseEvent) {
	if (item.type === SearchResultType.DIRECT && !employees.me?.currentCall) {
		call(item.numbers[0]?.number as string)
	} else {
		highlightedSearchResult.value = item
		searchContextMenu.value?.toggle(event)
	}
}

function searchContextMenuHideEvent() {
	searchContextMenuIsVisible.value = false
	document.removeEventListener('keydown', searchContextMenuKeydown)
	if (showSearchResults.value) {
		const searchInput = document.getElementById('MainSearchInput') as HTMLInputElement
		if (searchInput) { searchInput.focus() }
	}
}

function searchContextMenuShowEvent() {
	searchContextMenuIsVisible.value = true
	document.addEventListener('keydown', searchContextMenuKeydown)
}

function searchContextMenuKeydown(event: KeyboardEvent) {
	if (event.key === 'Enter') {
		event.preventDefault()
		if (searchContextMenuIsVisible.value && highlightedSearchResult.value && highlightedSearchResult.value.numbers.length > 0) {
			call(ss.cutNationalPrefix(highlightedSearchResult.value.numbers[0]?.number as string))
			searchContextMenu.value?.hide()
			clearSearch()
		}
	}
}

function numberTypeToPiIcon(type: string) {
	switch (type) {
		case 'MAIN':
			return 'pi pi-building'
		case 'MOBILE':
			return 'pi pi-mobile'
		case 'DIRECT':
			return 'pi pi-user'
		case 'HOME':
			return 'pi pi-home'
		case 'WORK':
			return 'pi pi-building'
		case 'EXTENSION':
			return 'pi pi-user'
		default:
			return 'pi pi-phone'
	}
}

const searchContextMenuItems = computed(() => {
	if (!highlightedSearchResult.value) { return [] }
	const sr = highlightedSearchResult.value

	const items: MenuItem[] = []

	if (sr.type === SearchResultType.PHONEBOOK && sr.numbers.length > 1) {
		const numberItems: MenuItem[] = []

		for (const number of sr.numbers) {
			numberItems.push({ label: number.label, icon: numberTypeToPiIcon(number.type), command: () => call(ss.cutNationalPrefix(number.number)) })
		}
		items.push({ label: t('topbar.searchCall'), icon: 'pi pi-phone', items: numberItems })
	} else if (sr.numbers.length > 0) {
		items.push({ label: t('topbar.searchCall'), icon: 'pi pi-phone', command: () => call(ss.cutNationalPrefix(sr.numbers[0]?.number as string)) })
	}

	if (employees.me?.currentCall) {
		if (sr.type === SearchResultType.PHONEBOOK && sr.numbers.length > 1) {
			const numberItems: MenuItem[] = []

			for (const number of sr.numbers) {
				numberItems.push({ label: number.label, icon: numberTypeToPiIcon(number.type), command: () => transferTo(ss.cutNationalPrefix(number.number)) })
			}
			items.push({ label: t('topbar.searchTransferTo'), icon: 'pi pi-arrow-right', items: numberItems })
		} else if (sr.numbers.length > 0) {
			items.push({ label: t('topbar.searchTransferTo'), icon: 'pi pi-arrow-right', command: () => transferTo(ss.cutNationalPrefix(sr.numbers[0]?.number as string)) })
		} else if (sr.type === SearchResultType.DIRECT) {
			items.push({ label: t('topbar.searchTransferTo'), icon: 'pi pi-arrow-right', command: () => transferTo(ss.cutNationalPrefix(sr.item as string)) })
		}
	}

	if (employees.me?.currentCall) {
		if (sr.type === SearchResultType.PHONEBOOK && sr.numbers.length > 1) {
			const numberItems: MenuItem[] = []

			for (const number of sr.numbers) {
				numberItems.push({ label: number.label, icon: numberTypeToPiIcon(number.type), command: () => invite(ss.cutNationalPrefix(number.number)) })
			}
			items.push({ label: t('topbar.searchInvite'), icon: 'pi pi-user-plus', items: numberItems })
		} else if (sr.numbers.length > 0) {
			items.push({ label: t('topbar.searchInvite'), icon: 'pi pi-user-plus', command: () => invite(ss.cutNationalPrefix(sr.numbers[0]?.number as string)) })
		} else if (sr.type === SearchResultType.DIRECT) {
			items.push({ label: t('topbar.searchInvite'), icon: 'pi pi-user-plus', command: () => invite(ss.cutNationalPrefix(sr.item as string)) })
		}
	}

	if (sr.sms) {
		items.push({
			label: t('topbar.searchSendSms'),
			icon: 'pi pi-comment',
			command: () => {
				clearSearch();
				(document.activeElement as HTMLElement)?.blur()
				globalEvents.emit('CommonSendSmsModal', { employee: sr.itemType === SearchResultItemType.EMPLOYEE ? sr.item as Employee : undefined, number: sr.sms })
			}
		})
	}

	if (sr.email) {
		items.push({
			label: t('topbar.searchSendEmail'),
			icon: 'pi pi-envelope',
			command: () => sendEmail(sr)
		})
	}

	if (sr.type === SearchResultType.PHONEBOOK) {
		items.push({
			label: t('topbar.searchInfo'),
			icon: 'pi pi-info-circle',
			command: () => {
				clearSearch();
				(document.activeElement as HTMLElement)?.blur()
				globalEvents.emit('Phonebook:Show', (sr.item as PbxPhonebookContact)._id)
			}
		})
	}

	if (sr.type === SearchResultType.EMPLOYEE) {
		const employee = sr.item as Employee
		if (employee.currentRingingCall && employee.permissions.pickup) {
			items.push({ label: t('topbar.searchPickup'), icon: 'pi pi-arrow-up', command: () => pickup(sr) })
		}
		if (employee.currentCall) {
			if (employee.permissions.steal) {
				items.push({ label: t('topbar.searchSteal'), icon: 'pi pi-user-minus', command: () => steal(sr) })
			}
			if (employee.permissions.spy) {
				items.push({ label: t('topbar.searchSpy'), icon: 'pi pi-eye', command: () => spy(sr) })
			}
		}
		if (employee.permissions.setPresence) {
			items.push({
				label: t('topbar.searchSetPresence'),
				icon: 'pi pi-user',
				command: () => {
					clearSearch();
					(document.activeElement as HTMLElement)?.blur()
					mySetPresenceModal.value?.show(employee)
				}
			})

			items.push({
				label: t('topbar.searchQuickSetPresence'),
				icon: 'pi pi-user-plus',
				items: [
					{ label: t('common.presence.AVAILABLE'), icon: 'pi pi-circle-full presence-available-color', command: () => setStatus(sr, EmployeePresenceState.AVAILABLE) },
					{ label: t('common.presence.BUSY'), icon: 'pi pi-circle-full presence-busy-color', command: () => setStatus(sr, EmployeePresenceState.BUSY) },
					{ label: t('common.presence.OUT_OF_OFFICE'), icon: 'pi pi-circle-full presence-out-of-office-color', command: () => setStatus(sr, EmployeePresenceState.OUT_OF_OFFICE) },
					{ label: t('common.presence.OFF_WORK'), icon: 'pi pi-circle-full presence-off-work-color', command: () => setStatus(sr, EmployeePresenceState.OFF_WORK) },
					{ label: t('common.presence.HOLIDAY'), icon: 'pi pi-circle-full presence-holiday-color', command: () => setStatus(sr, EmployeePresenceState.HOLIDAY) }
				]
			})

			items.push({
				label: t('topbar.searchSetRedirect'),
				icon: 'pi pi-arrow-right',
				command: () => {
					clearSearch();
					(document.activeElement as HTMLElement)?.blur()
					globalEvents.emit('CommonSetRedirectModal', employee)
				}
			})
		}

		if (ss.auth?.customerIntegrations.ms365?.enabled) {
			items.push({
				label: t('topbar.searchCalendar'),
				icon: 'pi pi-calendar',
				command: () => { globalEvents.emit('CommonCalendarModal', employee) }
			})
		}

		items.push({
			label: t('topbar.searchInfo'),
			icon: 'pi pi-info-circle',
			command: () => {
				clearSearch();
				(document.activeElement as HTMLElement)?.blur()
				globalEvents.emit('CommonEmployeeDataModal', employee)
			}
		})
	}

	return items
})

function keycheck(event: KeyboardEvent) {
	if (event.key === 'Escape') {
		event.preventDefault()
		clearSearch()
		return
	}

	if (searchResults.value.length === 0) { return }

	else if (event.key === 'Enter') {
		event.preventDefault()
		if (highlightedSearchResult.value) {
			const targetDiv = document.getElementById(`searchResultItem${(highlightedSearchResult.value as SearchResult).index}`)
			const rect = targetDiv?.getBoundingClientRect()
			if (!targetDiv || !rect) { return }

			const clientX = rect.left
			const clientY = rect.bottom

			const mouseEvent = new MouseEvent('click', {
				bubbles: true,
				cancelable: true,
				clientX: clientX,
				clientY: clientY
			})

			targetDiv.dispatchEvent(mouseEvent)
		}
	} else if (event.key === 'ArrowUp') {
		event.preventDefault()
		const index = highlightedSearchResult.value?.index as number
		if (index > 0) {
			highlightedSearchResult.value = searchResults.value[index - 1] as SearchResult
		}
	} else if (event.key === 'ArrowDown') {
		event.preventDefault()
		const index = highlightedSearchResult.value?.index as number
		if (searchResults.value[index + 1]) {
			highlightedSearchResult.value = searchResults.value[index + 1] as SearchResult
		}
	}
}

function hideOnClickOutside(element: HTMLElement) {
	const outsideClickListener = (event: MouseEvent) => {
		if (!element.contains(event.target as Node) && !(event.target as HTMLElement).classList.contains('search-field')) {
			clearSearch()
		}
	}

	const removeClickListener = () => {
		document.removeEventListener('click', outsideClickListener)
	}

	document.addEventListener('click', outsideClickListener)
	return removeClickListener
}

// function focusFirstItem() {
// 	nextTick(() => {
// 		const menu = document.getElementById('searchContextMenu') as HTMLElement
// 		if (menu) {
// 			const firstMenuItem = menu.querySelector('.p-contextmenu-item') as HTMLElement
// 			if (firstMenuItem) {
// 				firstMenuItem.focus()
// 			}
// 		}
// 	})
// }

// #endregion

// #region Search context menu actions

function pickup(item: SearchResult) {
	const employee = item.item as Employee
	const call = employee.currentRingingCall

	clearSearch();
	(document.activeElement as HTMLElement)?.blur()

	if (call && ss.realPhoneId) {
		logger.info(`Search: User is picking up a ringing phone from ${employee.name} with caller ${(call.leg === 'I' ? call.callee.number : call.caller.number)}`)
		globalEvents.emit('MyCallsAutoAnswerNextRinging', call.sessionId)
		api.get(`/pbx/app/action/pickup?device=${ss.realPhoneId}&target=${call._id}`).catch(() => {
			globalEvents.emit('CommonErrorModal', { header: t('common.error.pickFailedHeader'), message: t('common.error.pickupFailedMessage') })
		})
	}
}

function steal(item: SearchResult) {
	const employee = item.item as Employee
	const call = employee.currentCall

	clearSearch();
	(document.activeElement as HTMLElement)?.blur()

	if (call && ss.realPhoneId) {
		logger.info(`Search: User is stealing an ongoing call from ${employee.name} who is talking to ${(call.leg === 'O' ? call.caller.number : call.callee.number)}`)
		globalEvents.emit('MyCallsAutoAnswerNextRinging', call.sessionId)
		api.get(`/pbx/app/action/steal?device=${ss.realPhoneId}&target=${call._id}`).catch(() => {
			globalEvents.emit('CommonErrorModal', { header: t('common.error.stealFailedHeader'), message: t('common.error.stealFailedMessage') })
		})
	}
}

function spy(item: SearchResult) {
	const employee = item.item as Employee
	const call = employee.currentCall

	clearSearch();
	(document.activeElement as HTMLElement)?.blur()

	if (call && ss.realPhoneId) {
		logger.info(`Employee: User is spying on ${employee.name} who is talking to ${(call.leg === 'O' ? call.caller.number : call.callee.number)}`)
		globalEvents.emit('MyCallsAutoAnswerNextRinging', call.sessionId)
		api.get(`/pbx/app/action/spy?device=${ss.realPhoneId}&target=${call._id}`).catch(() => {
			globalEvents.emit('CommonErrorModal', { header: t('common.error.spyFailedHeader'), message: t('common.error.spyFailedMessage') })
		})
	}
}

function sendEmail(item: SearchResult) {
	const call = employees.me?.currentCall
	let message = ''

	clearSearch();
	(document.activeElement as HTMLElement)?.blur()

	if (call) {
		const caller = call.leg === 'O' ? call.caller : call.callee
		if (caller.name) {
			message = t('employee.emailMessageWithName').replace('%%name%%', caller.name).replace('%%number%%', ss.cutNationalPrefix(caller.number))
		} else {
			message = t('employee.emailMessage').replace('%%number%%', ss.cutNationalPrefix(caller.number))
		}
	}
	logger.info(`Search: User is writing an e-mail to ${item.type === SearchResultType.EMPLOYEE ? (item.item as Employee).name : 'n/a'} at ${item.email}`)
	if (message) {
		window.open(`mailto:${item.email}?subject=${encodeURIComponent(t('employee.emailSubject'))}&body=${encodeURIComponent(message)}`, '_blank')
	} else {
		window.open(`mailto:${item.email}`, '_blank') // ?subject=telefonbesked&body=et kald fra....
	}
}

async function setStatus(item: SearchResult, state: EmployeePresenceState) {
	const employee = item.item as Employee

	clearSearch();
	(document.activeElement as HTMLElement)?.blur()

	logger.info(`Employee: User is setting status for ${employee.name} to ${state}`)
	const employeeSubset: Partial<EmployeeRequest> = { presence: { state: state } }// , expire: null, message: '', location: '' } };
	if (state === EmployeePresenceState.AVAILABLE && employeeSubset.presence) {
		employeeSubset.presence.expire = null
		employeeSubset.presence.message = ''
		employeeSubset.presence.location = ''
	}

	try { await api.post<EmployeeResponse>(`/employee/${employee._id}`, employeeSubset) }
	catch (_) {
		globalEvents.emit('CommonErrorModal', { header: t('common.error.setPresenceFailedHeader'), message: t('common.error.setPresenceFailedMessage').replace('%%name%%', employee.name) })
	}
}

async function call(number: string) {
	clearSearch();
	(document.activeElement as HTMLElement)?.blur()

	if (!ss.realPhoneId) {
		globalEvents.emit('CommonErrorModal', { header: t('common.error.noPhoneHeader'), message: t('common.error.noPhoneMessage') })
		return
	}

	logger.info(`Topbar: User is calling ${number} via search menu`)
	if (ss.settings.softphoneId) {
		globalEvents.emit('Call:ActivateHold')
		await sleep(100)
		sipClient.call(number)
	} else {
		api.get(`/pbx/app/action/call?device=${ss.realPhoneId}&target=${encodeURIComponent(number)}`).catch(err => {
			globalEvents.emit('CommonErrorModal', { header: t('common.error.callFailedHeader'), message: t('common.error.callFailedMessage') })
			logger.error(`Topbar: User call to ${number} failed: ${(err as Error).message}`)
		})
	}
}

async function transferTo(number: string) {
	clearSearch();
	(document.activeElement as HTMLElement)?.blur()

	// Blind transfer
	if (!employees.me?.currentCall) {
		globalEvents.emit('CommonErrorModal', { header: t('common.error.noCallHeader'), message: t('common.error.noCallMessage') })
		return
	}
	logger.info(`TopBar: User made a blind transfer of ${(employees.me.currentCall.leg === 'I' ? employees.me.currentCall.callee.number : employees.me.currentCall.caller.number)} to ${number}`)
	globalEvents.emit('BlindTransferRequested', { source: employees.me.currentCall._id, target: number })
	api.get(`/pbx/app/action/transfer?source=${employees.me.currentCall._id}&target=${number}`).catch(err => {
		globalEvents.emit('CommonErrorModal', { header: t('common.error.transferFailedHeader'), message: t('common.error.transferFailedMessage') })
		logger.error(`Topbar: User blind transfer to ${number} failed: ${(err as Error).message}`)
	})
}

async function invite(number: string) {
	clearSearch();
	(document.activeElement as HTMLElement)?.blur()

	// Add to existing call
	if (!employees.me?.currentCall) {
		globalEvents.emit('CommonErrorModal', { header: t('common.error.noCallHeader'), message: t('common.error.noCallMessage') })
		return
	}
	logger.info(`TopBar: User is inviting ${number} to join existing call`)
	api.get(`/pbx/app/action/invite?source=${employees.me.currentCall._id}&target=${number}`).catch(err => {
		globalEvents.emit('CommonErrorModal', { header: t('common.error.inviteFailedHeader'), message: t('common.error.inviteFailedMessage').replace('%%number%%', number) })
		logger.error(`Topbar: User invite ${number} into call failed: ${(err as Error).message}`)
	})
}

// #endregion

async function audioInDeviceSelect(device: MediaDeviceSettingsItem) {
	mediaDevices.setMicrophoneDeviceId(device.value)
	const group = mediaDevices.deviceGroups.find(group => group.groupId === device.group)

	if (group) {
		const speakerDevice = group.devices.find(device => device.kind === MediaDeviceType.audiooutput)

		if (speakerDevice) {
			mediaDevices.setSpeakerDeviceId(speakerDevice.deviceId)
			logger.info(`Topbar: User selected microphone and speaker device: ${device.label}`)
		} else {
			// In case devices microphone and speaker does not share groupId - try to match on name instead
			const speakerDevice = mediaDevices.devices.find(dev => dev.kind === MediaDeviceType.audiooutput && dev.label === device.label)

			if (speakerDevice) {
				mediaDevices.setSpeakerDeviceId(speakerDevice.deviceId)
				logger.info(`Topbar: User selected microphone and speaker device: ${device.label}`)
			}
		}
	} else {
		logger.info(`Topbar: User selected microphone device: ${device.label}`)
	}
}

const impersonated = computed(() => !!ss.auth?.impersonatedBy)

const myPhoneName = computed(() => {
	if (!ss.realPhoneId) { return t('topbar.noPhoneSelected') }
	if (ss.settings.softphoneId) { return t('topbar.softphone') }
	if (employees.me) {
		const phone = employees.me.primaryExtension?.phones?.find(phone => phone._id === ss.realPhoneId)
		if (phone) {
			if (phone.name) {
				return `${ss.cutNationalPrefix(phone.name)} (${phone.model || t('topbar.mobile')})`
			} else {
				return phone.model || t('topbar.mobile')
			}
		}
		return t('topbar.unknown')
	} else {
		return t('topbar.unknownEmployee')
	}
})

const softphoneNotConnected = computed(() => {
	if (!ss.settings.softphoneId) { return false }
	if (sipClient.registered.value) { return false }
	return true
})

// Initialization

globalEvents.on('FocusSearch', () => {
	const el = document.getElementById('MainSearchInput') as HTMLInputElement

	if (el) {
		el.value = ''
		el.focus()
	}
})

globalEvents.on('Layout:Wallboard', enabled => { hide.value = enabled })

globalEvents.on('Voicemail:Count', data => {
	if (data.newMessages > 0) {
		voicemailBadge.value = `${data.newMessages}`
	} else {
		voicemailBadge.value = undefined
	}
})

globalEvents.on('SelectTopbarButton', (index: number) => {
	const id = buttonsIds.value[index]
	if (id === SectionType.RECORDINGS) {
		ss.recordingsModalVisible = !ss.recordingsModalVisible
	} else if (id === SectionType.VOICEMAIL) {
		ss.voicemailModalVisible = !ss.voicemailModalVisible
	} else if (id === SectionType.CALLS) {
		ss.cdrModalVisible = !ss.cdrModalVisible
	} else {
		ss.runtime.selectedSection = id as string
		globalEvents.emit('Dashboard:Select', (id as string).substring(10))
	}
})
</script>

<style scoped>
	.button-outer-container {
		height: 60px;
		overflow: hidden;
		order: 2;
	}
	.button-container {
		display:flex;
		justify-content:space-around;
		overflow-x: auto;
		overflow-y: hidden;
	}
	@media (max-width: 849px) {
		.button-container {
			background-color: var(--topbar-small-background);
			border-radius: 10px;
			border: var(--topbar-small-border);
		}
		.my-presence-box {
			-webkit-app-region: no-drag;
			order: 1;
		}
	}
	.my-presence-box {
		flex-grow: 0;
		flex-shrink: 0;
		order: 1;
	}

	.top-bar {
		-webkit-app-region: drag;
		position: fixed;
		-webkit-user-select: none;
		user-select: none;
		top: 0;
		width: 100%;
		background: var(--topbar-background);
		box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.25);
		z-index: 100;
		padding-left: 10px;
		padding-right: 10px;
		padding-top: 5px;
		padding-bottom: 5px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-end;
	}
	@media (max-width:849px) {
		.top-bar {
			flex-direction: column;
			align-items: stretch;
		}
	}
	.mainsearch {
		transition: width 0.5s;
		order: 3;
	}
	.search-helper {
		-webkit-app-region: no-drag;
		margin-top: 0px;
		margin-right: 10px;
		margin-bottom: -2px;
		text-align: right;
		font-size: 11px;
		color: var(--p-text-muted-color);
		font-style: italic;
	}
	.search-field {
		-webkit-app-region: no-drag;
		border-radius: 14px;
		width: 300px;
		transition: width 0.5s;
	}
	@media (min-width:850px) and (max-width:1150px) {
		.search-field {
			width: 200px;
		}
	}
	@media (max-width: 849px) {
		.search-field {
			width: 300px;
			float: right;
		}
	}
	@media (max-width: 390px) {
		.search-field {
			width: 100%;
		}
	}
	@media(max-width:849px) {
		.button-outer-container {
			order: -1;
		}
	}
	.search-field-extra {
		border-bottom-left-radius: 0;
		border-bottom-right-radius: 0;
	}
	.search-field-no-match {
		background-color: var(--topbar-search-no-match-background) !important;
		border: var(--topbar-search-no-match-border) !important;
		color: var(--topbar-search-no-match-color) !important;
	}
	.search-results-box {
		-webkit-app-region: no-drag;
		position: absolute;
		width: 300px;
		background: var(--topbar-search-result-background);
		border: 1px solid var(--topbar-search-border);
		right: 9px;
		top: 68px;
		z-index: 100;
		text-align: left;
		overflow-y: scroll;
	}
	@media (max-width: 849px) {
		.search-results-box {
			top: 168px;
		}
	}
	/* The search result menu is rendered inside the top bar rather than in the body (append-to="self"),
	so it inherits the window drag region and has to opt out of it too - inside a drag region the
	window manager takes the mouse events and its entries cannot be clicked. */
	.mainsearch :deep(.p-contextmenu) {
		-webkit-app-region: no-drag;
	}
	.search-result-item {
		border-bottom: 1px solid var(--topbar-search-border);
		height: 42px;
		cursor: pointer;
		transition: 999ms;
	}
	.search-result-item:last-of-type {
		border-bottom: none;
	}
	.search-result-item.selected {
		background-image: var(--topbar-search-result-selected) !important;
		color: var(--p-primary-contrast-color) !important;
		text-shadow: 1px 1px #00000020;
		transition: 200ms;
	}
	.search-result-item:nth-child(even) {
		background-color: #00000010;
	}

	@media(prefers-color-scheme: dark) {
		.search-result-item:nth-child(even) {
			background-color: #00000040;
		}
	}
	.search-result-item > DIV {
		padding: 2px 5px;
	}
	.result-item-employee {
		float: left;
		margin-right: 5px;
		display: flex;
	}
	.result-item-icon {
		float: left;
		margin-right: 5px;
		background: #00000010;
		border-radius: 25px;
		margin-top: 1px;
		border: 1px solid #00000040;
		width: 36px;
		height: 36px;
	}
	.search-result-item.selected > DIV > .result-item-icon {
		background: #FFFFFF80;
	}

	@media(prefers-color-scheme: dark) {
		.result-item-icon {
			background: #00000060;
		}
		.search-result-item.selected > DIV > .result-item-icon {
			background: #00000080;
		}
	}
	.search-result-item > DIV > .headline {
		font-size: 13px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.search-result-item > DIV > .subline {
		margin-top:-4px;
		font-size: var(--font-size-secondary) !important;
		overflow: hidden;
		white-space: nowrap;
	}
	.search-result-item > DIV > .subline > .badge {
		font-size: 10px;
		background-color: #00000010;
		border: 1px solid #00000020;
		color: var(--p-text-muted-color);
		border-radius: 10px;
		padding: 1px 5px 1px 5px;
		text-shadow: none;
		margin-right: 3px;
	}
	.search-result-item.selected > DIV > .subline > .badge {
		color: var(--p-primary-200);
		background-color: #00000020;
	}
	@media(prefers-color-scheme: dark) {
		.search-result-item > DIV > .subline > .badge {
			background-color: #00000080;
			border: 1px solid #000000e0;
			color: var(--p-text-muted-color);
		}
		.search-result-item.selected > DIV > .subline > .badge {
			color: var(--p-primary-900);
			border: 1px solid #00000020;
		}
	}
	.presence-state {
		position: absolute;
		margin-top: 20px;
		margin-left: 23px;
		flex-shrink: 0;
	}
	.employee-oncall {
		position: absolute;
		margin-top: 0px;
		margin-left: 23px;
		flex-shrink: 0;
		border: 1px solid var(--presence-busy);
		border-radius: 50%;
		z-index: 1;
		width: 16px;
		height: 16px;
		background-color:var(--presence-busy);
		opacity: 0;
		transition: 1s;
	}
	.employee-oncall.active {
		opacity: 1;
	}
	.phone-and-headset {
		-webkit-app-region: no-drag;
		width: 300px;
		font-size: 11px;
		display: flex;
		color: var(--p-text-muted-color);
		transition: width 0.5s;
		justify-content: flex-start;
		align-items: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	@media (min-width:850px) and (max-width:1150px) {
		.phone-and-headset {
			width: 200px;
		}
	}
	@media (max-width: 849px) {
		.phone-and-headset {
			width: 100%;
			background: var(--p-surface-200);
			border-radius: 7px;
			padding-left:5px;
			padding-right: 5px;
			margin-top: 2px;
		}
	}
	@media(prefers-color-scheme: dark) and (max-width: 849px) {
		.phone-and-headset {
			margin-top: 4px;
			background: var(--p-surface-950);
		}
	}
	.softphone-not-connected {
		color: red !important;
	}
	.impersonation {
		background: repeating-linear-gradient(
			45deg,
			#fcf7f2C0,
			#fcf7f2C0 10px,
			#ece7e280 10px,
			#ece7e280 20px
			), var(--topbar-background);
	}
	@media(prefers-color-scheme: dark) {
		.impersonation {
		background: repeating-linear-gradient(
			45deg,
			#fcf7f220,
			#fcf7f220 10px,
			#ece7e210 10px,
			#ece7e210 20px
			), var(--topbar-background);
		}
	}
	.audio-device-icon {
		flex-grow: 0;
		flex-shrink: 0;
		margin-left: 10px;
		cursor: pointer;
		margin-top: -2px;
	}
	.audio-device-label {
		flex-grow: 0;
		padding-left: 1px;
		white-space: nowrap;
		cursor: pointer;
	}

</style>
